import { render, staticRenderFns } from "./DetailDocuments.vue?vue&type=template&id=72262f59&scoped=true"
import script from "./DetailDocuments.vue?vue&type=script&lang=js"
export * from "./DetailDocuments.vue?vue&type=script&lang=js"
import style0 from "./DetailDocuments.vue?vue&type=style&index=0&id=72262f59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72262f59",
  null
  
)

export default component.exports